import { render, staticRenderFns } from "./defaultSizes.vue?vue&type=template&id=4181db52&"
import script from "./defaultSizes.vue?vue&type=script&lang=js&"
export * from "./defaultSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports